import { ConsentTracking, ContactStatus } from '@dev/ee-api/ee-api-models';

export const ALL_CONTACTS_LIST = '0';
export const ALL_CONTACTS_LIST_NAME = 'allcontacts';

export type StyledProps = {
    isMobile: boolean;
};

export type PostContactsParamsBodyProps = {
    email?: string;
    firstname?: string;
    lastname?: string;
};

export type PostContactsParamsProps = {
    body: PostContactsParamsBodyProps[];
    status: ContactStatus;
    consentTracking: ConsentTracking;
    listName: string;
};

export type NavigationProps = {
    listName: string;
    segmentName: string;
};

export type ContactDetailsInputProps = {
    name: string;
    setAddContactParam(param: string, target: string): void;
    value: string;
    emailError: boolean;
    errorMessage: string;
};

export type ListDetailsProps = {
    postContactsParams: PostContactsParamsProps;
    listName: string;
    segmentName: string;
    setAddContactParam(param: string, target: any): void;
};

export type SelectTrackingRadioProps = {
    postContactsParams: PostContactsParamsProps;
    setAddContactParam(param: string, target: any): void;
};

export type ContactStatusesProps = {
    value: ContactStatus;
    label: string;
};

export type ContactListsProps = {
    value: string;
    label: string;
};

export enum AddContactParams {
    Status = 'status',
    ListName = 'listName',
    ConsentTracking = 'consentTracking',
}
